<template>
  <section id="response_message" class="py-12 px-4">
    <div class="pb-8">
      <h2 class="text-center speedee-bd text-3xl pb-8">
        Datenänderung - TIPI
      </h2>
    </div>
    <div
      class="md:w-9/12 m-auto shadow-mcd-form rounded-mcd-lg px-4 md:px-12 lg:px-24 xl:px-48"
    >
      <!-- preloader START -->
      <Preloader v-if="submitStatus == 'LOADING'" />
      <!-- preloader END -->
      <div class="py-16 items-center justify-center" v-if="response.message">
        <h2 class="text-center speedee-bd text-3xl pb-8">
          {{ response.message }}
        </h2>
        <p>
          Deine Daten wurden nicht gespeichert. Klicke
          <a href="/familyplus" class="underline">hier</a>, um dich noch einmal
          anzumelden.
        </p>
      </div>
      <div v-else class="py-16">
        <!-- E-Mail START -->
        <div class="pt-4">
          <input
            class="w-full bg-white h-14 px-5 rounded focus:outline-none cursor-default"
            :class="[
              submitStatus == 'ERROR' && !$v.email.email ? 'error' : '',
              submitStatus == 'ERROR' && !$v.email.required ? 'error' : '',
            ]"
            type="email"
            name="email"
            placeholder="E-Mail*"
            v-model.trim="$v.email.$model"
            readonly
          />
          <div class="text-red-600 text-sm pt-2">
            <p v-if="submitStatus == 'ERROR' && !$v.email.required">
              Erforderlich
            </p>
            <p v-if="submitStatus == 'ERROR' && !$v.email.email">
              Eine gültige E-Mail-Adresse ist erforderlich.
            </p>
          </div>
        </div>
        <!-- E-Mail END -->
        <!-- TIPI START -->
        <div class="pt-8">
          <template>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-y-2 gap-x-4">
              <div>
                <input
                  class="w-full bg-white h-14 px-5 rounded focus:outline-none"
                  type="text"
                  name="tipi_name"
                  placeholder="Vorname Elternteil*"
                  v-model.trim="$v.tipi.tipi_name.$model"
                  :class="[
                    submitStatus == 'ERROR' && !$v.tipi.tipi_name.required
                      ? 'error'
                      : '',
                  ]"
                />
                <div class="text-red-600 text-sm pt-1 md:pt-2">
                  <p
                    v-if="
                      submitStatus == 'ERROR' && !$v.tipi.tipi_name.required
                    "
                  >
                    Erforderlich
                  </p>
                </div>
              </div>
              <div>
                <input
                  class="w-full bg-white h-14 px-5 rounded focus:outline-none"
                  type="text"
                  name="tipi_lastname"
                  placeholder="Nachname Elternteil*"
                  v-model.trim="$v.tipi.tipi_lastname.$model"
                  :class="[
                    submitStatus == 'ERROR' && !$v.tipi.tipi_lastname.required
                      ? 'error'
                      : '',
                  ]"
                />
                <div class="text-red-600 text-sm pt-2">
                  <p
                    v-if="
                      submitStatus == 'ERROR' && !$v.tipi.tipi_lastname.required
                    "
                  >
                    Erforderlich
                  </p>
                </div>
              </div>
            </div>
            <!-- Name, last name TIPI END -->
            <!-- Address TIPI START -->
            <div class="grid grid-cols-4 gap-x-4 gap-y-1 pt-1">
              <div class="col-span-4 md:col-span-2">
                <input
                  class="w-full bg-white h-14 px-5 rounded focus:outline-none"
                  type="text"
                  name="tipi_street"
                  placeholder="Straße*"
                  v-model.trim="$v.tipi.tipi_street.$model"
                  :class="[
                    submitStatus == 'ERROR' && !$v.tipi.tipi_street.required
                      ? 'error'
                      : '',
                  ]"
                />
                <div class="text-red-600 text-sm pt-2">
                  <p
                    v-if="
                      submitStatus == 'ERROR' && !$v.tipi.tipi_street.required
                    "
                  >
                    Erforderlich
                  </p>
                </div>
              </div>
              <div class="col-span-2 md:col-span-1">
                <input
                  class="w-full bg-white h-14 px-5 rounded focus:outline-none"
                  type="text"
                  name="tipi_number"
                  placeholder="Hausnr.*"
                  v-model.trim="$v.tipi.tipi_number.$model"
                  :class="[
                    submitStatus == 'ERROR' && !$v.tipi.tipi_number.required
                      ? 'error'
                      : '',
                  ]"
                />
                <div class="text-red-600 text-sm pt-2">
                  <p
                    v-if="
                      submitStatus == 'ERROR' && !$v.tipi.tipi_number.required
                    "
                  >
                    Erforderlich
                  </p>
                </div>
              </div>
              <div class="col-span-2 md:col-span-1">
                <input
                  class="w-full bg-white h-14 px-5 rounded focus:outline-none"
                  type="text"
                  name="tipi_top"
                  placeholder="Top/Stiege"
                  v-model="tipi.tipi_top"
                />
              </div>
              <div class="col-span-4 md:col-span-1">
                <input
                  class="w-full bg-white h-14 px-5 rounded focus:outline-none"
                  type="text"
                  name="tipi_plz"
                  placeholder="PLZ*"
                  v-model.trim="$v.tipi.tipi_plz.$model"
                  :class="[
                    submitStatus == 'ERROR' && !$v.tipi.tipi_plz.required
                      ? 'error'
                      : '',
                  ]"
                />
                <div class="text-red-600 text-sm pt-2">
                  <p
                    v-if="submitStatus == 'ERROR' && !$v.tipi.tipi_plz.required"
                  >
                    Erforderlich
                  </p>
                </div>
              </div>
              <div class="col-span-4 md:col-span-3">
                <input
                  class="w-full bg-white h-14 px-5 rounded focus:outline-none"
                  type="text"
                  name="tipi_city"
                  placeholder="Ort*"
                  v-model.trim="$v.tipi.tipi_city.$model"
                  :class="[
                    submitStatus == 'ERROR' && !$v.tipi.tipi_city.required
                      ? 'error'
                      : '',
                  ]"
                />
                <div class="text-red-600 text-sm pt-2">
                  <p
                    v-if="
                      submitStatus == 'ERROR' && !$v.tipi.tipi_city.required
                    "
                  >
                    Erforderlich
                  </p>
                </div>
              </div>
            </div>
          </template>
          <!-- Check box TIPI START -->
          <label class="flex justify-start items-start pt-8">
            <div
              class="rounded-md w-6 h-6 flex flex-shrink-0 justify-center items-center mr-4"
              :class="[
                submitStatus == 'ERROR' && $v.tipi.isVisible.$error
                  ? 'error'
                  : '',
                tipi.isVisible ? 'bg-mcdonalds-yellow' : 'bg-mcdonalds-gray',
              ]"
            >
              <input
                type="checkbox"
                name="tipi"
                class="opacity-0 absolute"
                v-model="tipi.isVisible"
              />
              <svg
                class="fill-current stroke-current stroke-2 hidden w-3 h-3 text-white pointer-events-none"
                viewBox="0 0 20 20"
              >
                <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
              </svg>
            </div>
            <div class="select-none font-light">
              *Ich stimme zu, dass die McDonald’s Werbegesellschaft m.b.H. mir
              viermal jährlich das Tipi Magazin per Post zusendet. Diese
              Zustimmung kann ich auch nachträglich jederzeit gegenüber
              McDonald’s per E-Mail an datenschutz@at.mcd.com widerrufen. Der
              Widerruf lässt die Rechtmäßigkeit der Verarbeitung bis zum
              Widerruf unberührt.
            </div>
          </label>
          <!-- Check box TIPI END -->
          <!-- Name, month, year TIPI child END -->
          <!-- Address TIPI END -->
        </div>
        <!-- TIPI END -->
        <div class="pt-4">
          <!-- Check box GPDR START -->
          <label class="flex justify-start items-start pb-2">
            <div
              class="rounded-md w-6 h-6 flex flex-shrink-0 justify-center items-center mr-4"
              :class="[
                submitStatus == 'ERROR' && $v.checkConditions.$error
                  ? 'error'
                  : '',
                checkConditions ? 'bg-mcdonalds-yellow' : 'bg-mcdonalds-gray',
              ]"
            >
              <input
                type="checkbox"
                name="tipi"
                class="opacity-0 absolute"
                v-model.trim="checkConditions"
                @change="$v.checkConditions.$touch()"
              />
              <svg
                class="fill-current stroke-current stroke-2 hidden w-3 h-3 text-white pointer-events-none"
                viewBox="0 0 20 20"
              >
                <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
              </svg>
            </div>
            <div class="select-none font-light">
              *Ich stimme den
              <a
                href="https://www.mcdonalds.at/familyplus/agb"
                class="underline text-mcdonalds-yellow"
                >Nutzungsbedingungen</a
              >
              zu und nehme die
              <a
                href="https://www.mcdonalds.at/datenschutz"
                class="underline text-mcdonalds-yellow"
                >Datenschutzerklärung</a
              >
              zur Kenntnis.
            </div>
          </label>
          <!-- Check box GPDR END -->
        </div>
        <div class="flex justify-center pt-12">
          <button
            class="bg-mcdonalds-yellow rounded-full py-4 px-16 text-black text-xl speedee-bd mt-4 focus:outline-none"
            @click="validateForm()"
          >
            Änderungen speichern
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { scrollToIdMixin } from "../mixins";
import Preloader from "./Preloader";
import { ValidationRulesEditTipi } from "./ValidationRulesEditTipi.js";

export default {
  components: {
    Preloader,
  },
  data() {
    return {
      submitStatus: null,
      response: {
        status: null,
        message: "",
      },
      guid: "",
      email: "",
      nl: false,
      tipi: {
        isVisible: false,
        tipi_name: "",
        tipi_lastname: "",
        tipi_street: "",
        tipi_number: null,
        tipi_top: "",
        tipi_plz: null,
        tipi_city: "",
      },
      gb: {
        isVisible: false,
      },
      checkConditions: false,
    };
  },
  validations() {
    return ValidationRulesEditTipi;
  },
  mixins: [scrollToIdMixin],
  methods: {
    // method to validate child components
    async validateForm() {
      // run vuelidate and check if there some errors
      this.$v.$touch();

      // if validation is false
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        let formData = new FormData();
        // create a json object from values to send to API
        let data = {
          guid: this.guid,
          tipi: this.tipi.isVisible,
          tipi_name: this.tipi.tipi_name,
          tipi_lastname: this.tipi.tipi_lastname,
          tipi_street: this.tipi.tipi_street,
          tipi_number: this.tipi.tipi_number,
          tipi_top: this.tipi.tipi_top,
          tipi_plz: this.tipi.tipi_plz,
          tipi_city: this.tipi.tipi_city,
          tipi_childs: this.tipi.tipi_child_db,
        };

        formData.append("data", JSON.stringify(data));

        if (this.gb.isVisible || this.tipi.isVisible || this.nl) {
          // if validation is true, but if child checkbox is checked/true
          const registerUser = await this.setData(formData);
          this.submitStatus = "OK";
          this.scrollToId();
        } else {
          this.$swal({
            icon: "error",
            title:
              "Hoppla, du hast kein Angebot ausgewählt. Versuch‘s nochmal!",
          });
        }
      }
    },
    async setData(formData) {
      //setup headers, method and values
      const settings = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
          "X-Requested-With": "XMLHttpRequest",
        },
      };

      this.submitStatus = "LOADING";
      this.axios
        .post(
          process.env.VUE_APP_WEBSERVICE_URL + "/?action=settipidata",
          formData,
          settings
        )
        .then(
          // get response if success
          async (dataRes) => {
            if (dataRes.data.success) {
              this.submitStatus = "OK";
              this.$swal({
                icon: "success",
                title:
                  "Danke für dein Update! Deine Daten wurden erfolgreich geändert.",
                showConfirmButton: false,
                html:
                  '<div class="my-8"><a href="https://www.mcdonalds.at/familyplus" class="bg-blue-600 rounded-md py-4 px-8 text-white text-2xl speedee-bd mt-4 swal2-confirm swal2-styled">OK</a></div>',
                allowOutsideClick: false,
              });
            } else if (dataRes.data.error) {
              this.response.status = "Error";
              this.response.message =
                "Leider ist der Link abgelaufen oder die Daten wurden bereits geändert.";
              this.submitStatus = "ERROR";
            } else {
              console.log(dataRes.data);
            }
          }
          // catch the errors
        )
        .catch(function(error) {});
    },
    async getData(guid) {
      let formData = new FormData();

      // create a json object from values to send to API
      let data = {
        guid: guid,
      };

      formData.append("data", JSON.stringify(data));
      //setup headers, method and values
      const settings = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
          "X-Requested-With": "XMLHttpRequest",
        },
      };
      this.submitStatus = "LOADING";
      this.axios
        .post(
          process.env.VUE_APP_WEBSERVICE_URL + "/?action=gettipidata",
          formData,
          settings
        )
        .then(
          // get response if success
          async (dataRes) => {
            this.submitStatus = null;
            let participant = dataRes.data.success;
            if (participant) {
              this.email = participant.email;
              this.tipi.tipi_name = participant.tipi_name;
              this.tipi.tipi_lastname = participant.tipi_lastname;
              this.tipi.tipi_street = participant.tipi_street;
              this.tipi.tipi_number = participant.tipi_number;
              this.tipi.tipi_top = participant.tipi_top;
              this.tipi.tipi_plz = participant.tipi_plz;
              this.tipi.tipi_city = participant.tipi_city;
            } else {
              this.response.status = "Error";
              this.response.message =
                "Leider ist der Link abgelaufen oder die Daten wurden bereits geändert.";
            }
          }
          // catch the errors
        )
        .catch(function(error) {});
    },
  },
  async mounted() {
    console.log("change tipi");
    // scroll to id

    console.log("changetipi");

    this.tipi.isVisible = false;
    // on load check if url params are set and set the in a variable
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    // get paramaters by name
    const changetipi = urlParams.get("changetipi");
    if (changetipi) {
      this.guid = changetipi;
      const getEditDataDb = await this.getData(this.guid);
    }
  },
};
</script>
